const beginnerVipIconList = {
    show5335: 0,
    show5865: 1,
    yanxuanTag: 1,
    material: 1,
    consultSetting: 1,
    allSiteRecommend: 1,
    freeConsult: 1,
    instantClues: 1,
    offlineQaPage: 0,
    articleClaim: 0,
    qaRecommendLawyer: 0,
    ruleTool: 1,
    caseTool: 1,
    aiContract: 1,
    aiInsurance: 1
};

const eliteVipIconList = {
    show5335: 1,
    show5865: 1,
    yanxuanTag: 1,
    material: 1,
    consultSetting: 1,
    allSiteRecommend: 1,
    freeConsult: 1,
    instantClues: 1,
    offlineQaPage: 1,
    articleClaim: 1,
    qaRecommendLawyer: 1,
    ruleTool: 1,
    caseTool: 1,
    aiContract: 1,
    aiInsurance: 1
};

const vipIconList = {
    show5335: 1,
    show5865: 1,
    yanxuanTag: 1,
    material: 1,
    consultSetting: 1,
    allSiteRecommend: 1,
    freeConsult: 1,
    instantClues: 1,
    offlineQaPage: 1,
    articleClaim: 1,
    qaRecommendLawyer: 1,
    ruleTool: 1,
    caseTool: 1,
    aiContract: 1,
    aiInsurance: 1
};

const freeVipIconList = {
    show5335: 1,
    show5865: 1,
    yanxuanTag: 1,
    material: 1,
    consultSetting: 1,
    allSiteRecommend: 1,
    freeConsult: 1,
    instantClues: 1,
    offlineQaPage: 1,
    articleClaim: 1,
    qaRecommendLawyer: 0,
    ruleTool: 1,
    caseTool: 1,
    aiContract: 1,
    aiInsurance: 1
};

const outVipIconList = {
    show5335: 0,
    show5865: 0,
    yanxuanTag: 0,
    material: 1,
    consultSetting: 0,
    allSiteRecommend: 0,
    freeConsult: 1,
    instantClues: 0,
    offlineQaPage: 0,
    articleClaim: 0,
    qaRecommendLawyer: 0,
    ruleTool: 1,
    caseTool: 1,
    aiContract: 1,
    aiInsurance: 1
};

const noVipIconList = {
    show5335: 0,
    show5865: 0,
    yanxuanTag: 0,
    material: 1,
    consultSetting: 0,
    allSiteRecommend: 0,
    freeConsult: 1,
    instantClues: 0,
    offlineQaPage: 0,
    articleClaim: 0,
    qaRecommendLawyer: 0,
    ruleTool: 1,
    caseTool: 1,
    aiContract: 1,
    aiInsurance: 1
};

const vcardVipIconList = {
    show5335: 0,
    show5865: 1,
    yanxuanTag: 0,
    material: 1,
    consultSetting: 0,
    allSiteRecommend: 0,
    freeConsult: 1,
    instantClues: 0,
    offlineQaPage: 0,
    articleClaim: 0,
    qaRecommendLawyer: 0,
    ruleTool: 1,
    caseTool: 1,
    aiContract: 1,
    aiInsurance: 1
};

export default {
    beginnerVipIconList,
    eliteVipIconList,
    vipIconList,
    freeVipIconList,
    outVipIconList,
    noVipIconList,
    vcardVipIconList
};